import SelectInput from '@/components/common/SelectInput';

export type PlusOrMinusValue = '+' | '-';

export const parseWithPlusOrMinus = (
    value: number,
    plusOrMinus: PlusOrMinusValue
): number => {
    const absValue = Math.abs(value);
    return plusOrMinus === '+' ? absValue : -absValue;
};

const OPTIONS: { value: PlusOrMinusValue; label: PlusOrMinusValue }[] = [
    { value: '+', label: '+' },
    { value: '-', label: '-' },
];

const PlusOrMinusInput = ({ ...props }) => {
    return <SelectInput size="lg" options={OPTIONS} {...props} />;
};

export default PlusOrMinusInput;
